<template id="page">
  <div class="pageWrap">
    <span @click.stop.prevent="pageChange(pageNo==1?1:1)" :class="{disabled:pageNo===1}">首页</span>
    <span @click.stop.prevent="pageChange(pageNo==1?1:pageNo-1)" :class="{disabled:pageNo===1}">上一页</span>
    <span @click.stop.prevent="pageChange(pageNo==pages?pages:pageNo+1)" :class="{disabled:pageNo===pages}">下一页</span>
    <span @click.stop.prevent="pageChange(pageNo==pages?pages:pages)" :class="{disabled:pageNo===pages}">尾页</span>
    <em>第 <input type="text" v-model="pageNo" style="width: 45px;height:16PX;" @change.stop.prevent="pageChange(pageNo==1?1:pageNo)">页 / 共 {{pages}} 页</em>      
    
  </div>
</template>
 
<script>
  export default {
    data: function () {
      return {
        // 当前页
        pageNo: 1,
        // 总页数
        pages: 1
      }
    },
    // 绑定页面传参
    watch:{
      current(val){
        this.pageNo = val
      }, 
      total(val){
        this.pages = Math.ceil(val/this.pageSize)
        if(this.pages < this.pageNo && this.pages > 0){
           this.pageNo = this.pages
        }
      }
    },
    props: {
      current:{
        type:Number,
        default:1,
        required: false
      },
      total: {// 总记录数
        type: Number,
        default: 1
      },
      pageSize: {// 每页显示条数
        type: Number,
        default: 10,
        required: false
      }
    },
    methods: {
      pageChange(page) {
        console.log(this.pageNo,page)
        if (this.pageNo != page) {
          this.pageNo = Number(page);
          this.$emit('navpage', page);
        }
      },
    }
  }
</script>
 
<style lang="less" scoped>
@import '../../../../static/function.less';
.pageWrap{
  text-align: right;
  font-size: @font14;
  margin: 3% 0;
  span{
    color: #2d9bf0;
    padding: 1%;
    margin: 0 5px;
    border: 1px solid #2d9bf0;
    background-color: #fff;
    cursor: pointer;
    &:hover{
      background-color: #2d9bf0;
      color: #fff;
    }
    &.disabled{
      cursor: not-allowed;
      background-color: #fff;
      color: #2d9bf0;
    }
  }
  em{
    margin-left: 10px;
  }
}</style>


// WEBPACK FOOTER //
// src/view/CloudFair/components/page.vue